const IconContainer = ({
  color = "",
  size = "26px",
  display = "flex",
  justifyContent = "center",
  alignItems = "center",
  children,
}) => {
  return (
    <div
      style={{
        display: display,
        justifyContent: justifyContent,
        alignItems: alignItems,
      }}
    >
      <svg
        className="customIcon"
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        width={size}
        viewBox="0 -960 960 960"
        style={{ fill: color }}
      >
        {children}
      </svg>
    </div>
  );
};

export const LockIcon = (props) => {
  return (
    <IconContainer {...props}>
      <path d="M252.31-100q-29.83 0-51.07-21.24Q180-142.48 180-172.31v-375.38q0-29.83 21.24-51.07Q222.48-620 252.31-620H300v-80q0-74.92 52.54-127.46Q405.08-880 480-880q74.92 0 127.46 52.54Q660-774.92 660-700v80h47.69q29.83 0 51.07 21.24Q780-577.52 780-547.69v375.38q0 29.83-21.24 51.07Q737.52-100 707.69-100H252.31ZM480-290q29.15 0 49.58-20.42Q550-330.85 550-360t-20.42-49.58Q509.15-430 480-430t-49.58 20.42Q410-389.15 410-360t20.42 49.58Q450.85-290 480-290ZM360-620h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80Z" />
    </IconContainer>
  );
};
export const UserIcon = (props) => {
  return (
    <IconContainer {...props}>
      <path d="M480-492.31q-57.75 0-98.87-41.12Q340-574.56 340-632.31q0-57.75 41.13-98.87 41.12-41.13 98.87-41.13 57.75 0 98.87 41.13Q620-690.06 620-632.31q0 57.75-41.13 98.88-41.12 41.12-98.87 41.12ZM180-187.69v-88.93q0-29.38 15.96-54.42 15.96-25.04 42.66-38.5 59.3-29.07 119.65-43.61 60.35-14.54 121.73-14.54t121.73 14.54q60.35 14.54 119.65 43.61 26.7 13.46 42.66 38.5Q780-306 780-276.62v88.93H180Z" />
    </IconContainer>
  );
};
export const EmailIcon = (props) => {
  return (
    <IconContainer {...props}>
      <path d="M172.31-180Q142-180 121-201q-21-21-21-51.31v-455.38Q100-738 121-759q21-21 51.31-21h615.38Q818-780 839-759q21 21 21 51.31v455.38Q860-222 839-201q-21 21-51.31 21H172.31ZM480-457.69l320-204.62-6.15-57.69L480-520 166.15-720 160-662.31l320 204.62Z" />{" "}
    </IconContainer>
  );
};
export const ChatBubbleIcon = (props) => {
  return (
    <IconContainer {...props}>
      <path d="M100-118.46v-669.23Q100-818 121-839q21-21 51.31-21h615.38Q818-860 839-839q21 21 21 51.31v455.38Q860-302 839-281q-21 21-51.31 21H241.54L100-118.46ZM250-410h300v-60H250v60Zm0-120h460v-60H250v60Zm0-120h460v-60H250v60Z" />{" "}
    </IconContainer>
  );
};
export const HistoryIcon = (props) => {
  return (
    <IconContainer {...props}>
      <path d="M479.23-140q-129.92 0-226.46-85.54Q156.23-311.08 141.62-440h61.23Q218-336.38 296.12-268.19 374.23-200 479.23-200q117 0 198.5-81.5t81.5-198.5q0-117-81.5-198.5T479.23-760q-65.54 0-122.84 29.12-57.31 29.11-98.7 80.11h104.62v60H159.23v-203.08h60v94.77q48.69-57.46 116.62-89.19Q403.77-820 479.23-820q70.77 0 132.62 26.77 61.84 26.77 107.84 72.77t72.77 107.85q26.77 61.84 26.77 132.61 0 70.77-26.77 132.61-26.77 61.85-72.77 107.85-46 46-107.84 72.77Q550-140 479.23-140Zm120.08-178.92L450.39-467.85V-680h59.99v187.85l131.08 131.07-42.15 42.16Z" />{" "}
    </IconContainer>
  );
};
export const NewsIcon = (props) => {
  return (
    <IconContainer {...props}>
      <path d="M212.31-140Q182-140 161-161q-21-21-21-51.31v-535.38Q140-778 161-799q21-21 51.31-21h419.23L820-631.54v419.23Q820-182 799-161q-21 21-51.31 21H212.31ZM290-300h380v-60H290v60Zm0-150h380v-60H290v60Zm310-150h160L600-760v160Zm-310 0h190v-60H290v60Z" />{" "}
    </IconContainer>
  );
};
export const ChartIcon = (props) => {
  return (
    <IconContainer {...props}>
      <path d="M294.62-290h59.99v-260h-59.99v260ZM450-290h60v-380h-60v380Zm155.39 0h59.99v-140h-59.99v140ZM212.31-140Q182-140 161-161q-21-21-21-51.31v-535.38Q140-778 161-799q21-21 51.31-21h535.38Q778-820 799-799q21 21 21 51.31v535.38Q820-182 799-161q-21 21-51.31 21H212.31Z" />{" "}
    </IconContainer>
  );
};
export const CalendarIcon = (props) => {
  return (
    <IconContainer {...props}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M438-240.62 309.85-368.77l43.38-43.38L438-327.38l168.77-168.77 43.38 43.38L438-240.62ZM212.31-100Q182-100 161-121q-21-21-21-51.31v-535.38Q140-738 161-759q21-21 51.31-21h55.38v-84.61h61.54V-780h303.08v-84.61h60V-780h55.38Q778-780 799-759q21 21 21 51.31v535.38Q820-142 799-121q-21 21-51.31 21H212.31Zm0-60h535.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-375.38H200v375.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85Z"
      />
    </IconContainer>
  );
};
export const ClockIcon = (props) => {
  return (
    <IconContainer {...props}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M367.69-850v-60h224.62v60H367.69ZM450-407.69h60v-224.62h-60v224.62ZM480-100q-70.15 0-132-26.77-61.85-26.77-108.15-73.08-46.31-46.3-73.08-108.15Q140-369.85 140-440t26.77-132q26.77-61.85 73.08-108.15 46.3-46.31 108.15-73.08Q409.85-780 480-780q60.08 0 115.73 20.39 55.65 20.38 103.35 58.38l49.84-49.84 42.15 42.15-49.84 49.84q38 47.7 58.38 103.35Q820-500.08 820-440q0 70.15-26.77 132-26.77 61.85-73.08 108.15-46.3 46.31-108.15 73.08Q550.15-100 480-100Z"
      />
    </IconContainer>
  );
};
export const CheckIcon = (props) => {
  return (
    <IconContainer {...props}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M382-221.91 135.91-468l75.66-75.65L382-373.22l366.43-366.43L824.09-664 382-221.91Z"
      />
    </IconContainer>
  );
};
export const PaletteIcon = (props) => {
  return (
    <IconContainer {...props}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M120-120v-190l358-358-58-56 58-56 76 76 124-124q5-5 12.5-8t15.5-3q8 0 15 3t13 8l94 94q5 6 8 13t3 15q0 8-3 15.5t-8 12.5L705-555l76 78-57 57-56-58-358 358H120Zm80-80h78l332-334-76-76-334 332v78Z"
      />
    </IconContainer>
  );
};
